<div class="prize-pool">
  <div class="prize-pool--header">
    <h3 class="prize-pool--heading">Prize Pool</h3>
    <span class="prize-pool--payment-badge" *ngIf="prizePool.paymentMethod">
      {{ prizePool.paymentMethod === 'cash' ? 'Cash' : prizePool.paymentMethod === 'cheque' ? 'Cheque' : prizePool.paymentMethod === 'cash or cheque' ? 'Cash or Cheque' : prizePool.paymentMethod }}
    </span>
  </div>
  <div class="prize-pool--amount">
    <span class="prize-pool--label">Total prize amount</span>
    <div class="prize-pool--value-wrapper">
      <span class="prize-pool--currency">₹</span>
      <span class="prize-pool--value">{{ prizePool.totalAmount | number:'1.0-0' }}</span>
    </div>
  </div>
  
  <!-- Prize Distribution -->
  <div class="prize-pool--distribution" *ngIf="prizePool.distribution && prizePool.distribution.length > 0">
    <div 
      class="prize-pool--distribution-item" 
      *ngFor="let item of prizePool.distribution"
    >
      <div class="prize-pool--position-wrapper">
        <!-- Medal Icons for 1st, 2nd, 3rd -->
        <div *ngIf="'position' in item && (item.position === '1st' || item.position === '2nd' || item.position === '3rd')" class="prize-pool--medal-icon">
          <!-- 1st Place Medal -->
          <svg *ngIf="item.position === '1st'" width="40" height="50" viewBox="0 0 80 100" fill="none">
            <!-- Ribbon -->
            <path d="M20 5 L25 5 L23 15 L18 15 Z" fill="#DC2626"/>
            <path d="M55 5 L60 5 L58 15 L53 15 Z" fill="#DC2626"/>
            <path d="M25 5 L30 5 L30 15 L25 15 Z" fill="#EF4444"/>
            <path d="M30 5 L35 5 L35 15 L30 15 Z" fill="#EF4444"/>
            <path d="M35 5 L40 5 L40 15 L35 15 Z" fill="#EF4444"/>
            <path d="M40 5 L45 5 L45 15 L40 15 Z" fill="#EF4444"/>
            <!-- Medal Loop -->
            <ellipse cx="40" cy="20" rx="3" ry="4" fill="#FFA500"/>
            <!-- Outer Gold Circle -->
            <circle cx="40" cy="50" r="28" fill="url(#prizePoolGoldGradient)" stroke="#FFA500" stroke-width="3"/>
            <!-- Inner Red Ring -->
            <circle cx="40" cy="50" r="22" fill="none" stroke="#DC2626" stroke-width="2"/>
            <!-- Inner Gold Circle -->
            <circle cx="40" cy="50" r="18" fill="url(#prizePoolGoldGradient)"/>
            <text x="40" y="57" text-anchor="middle" font-size="16" font-weight="bold" fill="#DC2626">1ST</text>
            <text x="40" y="70" text-anchor="middle" font-size="8" font-weight="bold" fill="#DC2626">PLACE</text>
            <defs>
              <linearGradient id="prizePoolGoldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#FFD700;stop-opacity:1" />
                <stop offset="100%" style="stop-color:#FFA500;stop-opacity:1" />
              </linearGradient>
            </defs>
          </svg>
          <!-- 2nd Place Medal -->
          <svg *ngIf="item.position === '2nd'" width="40" height="50" viewBox="0 0 80 100" fill="none">
            <!-- Ribbon -->
            <path d="M20 5 L25 5 L23 15 L18 15 Z" fill="#6B7280"/>
            <path d="M55 5 L60 5 L58 15 L53 15 Z" fill="#6B7280"/>
            <path d="M25 5 L30 5 L30 15 L25 15 Z" fill="#9CA3AF"/>
            <path d="M30 5 L35 5 L35 15 L30 15 Z" fill="#9CA3AF"/>
            <path d="M35 5 L40 5 L40 15 L35 15 Z" fill="#9CA3AF"/>
            <path d="M40 5 L45 5 L45 15 L40 15 Z" fill="#9CA3AF"/>
            <!-- Medal Loop -->
            <ellipse cx="40" cy="20" rx="3" ry="4" fill="#808080"/>
            <!-- Outer Silver Circle -->
            <circle cx="40" cy="50" r="28" fill="url(#prizePoolSilverGradient)" stroke="#808080" stroke-width="3"/>
            <!-- Inner Ring -->
            <circle cx="40" cy="50" r="22" fill="none" stroke="#6B7280" stroke-width="2"/>
            <!-- Inner Circle -->
            <circle cx="40" cy="50" r="18" fill="url(#prizePoolSilverGradient)"/>
            <text x="40" y="57" text-anchor="middle" font-size="16" font-weight="bold" fill="#6B7280">2ND</text>
            <text x="40" y="70" text-anchor="middle" font-size="8" font-weight="bold" fill="#6B7280">PLACE</text>
            <defs>
              <linearGradient id="prizePoolSilverGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#E8E8E8;stop-opacity:1" />
                <stop offset="100%" style="stop-color:#C0C0C0;stop-opacity:1" />
              </linearGradient>
            </defs>
          </svg>
          <!-- 3rd Place Medal -->
          <svg *ngIf="item.position === '3rd'" width="40" height="50" viewBox="0 0 80 100" fill="none">
            <!-- Ribbon -->
            <path d="M20 5 L25 5 L23 15 L18 15 Z" fill="#92400E"/>
            <path d="M55 5 L60 5 L58 15 L53 15 Z" fill="#92400E"/>
            <path d="M25 5 L30 5 L30 15 L25 15 Z" fill="#B45309"/>
            <path d="M30 5 L35 5 L35 15 L30 15 Z" fill="#B45309"/>
            <path d="M35 5 L40 5 L40 15 L35 15 Z" fill="#B45309"/>
            <path d="M40 5 L45 5 L45 15 L40 15 Z" fill="#B45309"/>
            <!-- Medal Loop -->
            <ellipse cx="40" cy="20" rx="3" ry="4" fill="#8B4513"/>
            <!-- Outer Bronze Circle -->
            <circle cx="40" cy="50" r="28" fill="url(#prizePoolBronzeGradient)" stroke="#8B4513" stroke-width="3"/>
            <!-- Inner Ring -->
            <circle cx="40" cy="50" r="22" fill="none" stroke="#92400E" stroke-width="2"/>
            <!-- Inner Circle -->
            <circle cx="40" cy="50" r="18" fill="url(#prizePoolBronzeGradient)"/>
            <text x="40" y="57" text-anchor="middle" font-size="16" font-weight="bold" fill="#92400E">3RD</text>
            <text x="40" y="70" text-anchor="middle" font-size="8" font-weight="bold" fill="#92400E">PLACE</text>
            <defs>
              <linearGradient id="prizePoolBronzeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#CD7F32;stop-opacity:1" />
                <stop offset="100%" style="stop-color:#8B4513;stop-opacity:1" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <!-- Text for ranges or other positions -->
        <span class="prize-pool--position" *ngIf="'range' in item || !('position' in item && (item.position === '1st' || item.position === '2nd' || item.position === '3rd'))">
          <ng-container *ngIf="'position' in item">{{ item.position }}</ng-container>
          <ng-container *ngIf="'range' in item">Rank {{ item.range }}</ng-container>
        </span>
      </div>
      <span class="prize-pool--amount-value">
        ₹{{ item.amount | number:'1.0-0' }}
      </span>
    </div>
  </div>
  
  <!-- Payment Method Note -->
  <div class="prize-pool--payment-note">
    Prize receiving will be in {{ prizePool.paymentMethod }}
  </div>
</div>


